/* eslint-disable jsx-a11y/no-noninteractive-tabindex */
/* eslint-disable @gandi/gandi/no-global-element */
// @flow
import * as React from 'react';

import capitalize from 'lodash/capitalize';

import { useTranslator } from '@gandi/translate';
import { Badge, Base, SrOnly } from '@gandi/ui';

import { PlanContent, type Options } from './PlanContent';

import styles from './PlanRow.scss';

export type Props = {
  duration?: number | null,
  isSelected: boolean,
  onSelect?: (evt: SyntheticInputEvent<>) => void,
  disabled?: boolean,
  id: string | number,
  value: string,
  price?: React.Node,
  detail?: React.Node,
  options?: Options,
};

export function PlanRow({
  detail,
  isSelected,
  onSelect,
  disabled,
  id,
  value,
  price,
  options,
  duration,
}: Props): React.MixedElement {
  const { __ } = useTranslator();

  const handleClick = (e: SyntheticInputEvent<>) => {
    if (!disabled && typeof onSelect === 'function') {
      onSelect(e);
    }
  };

  const sizeLabel =
    value === 'essential' ? (
      <Base flex gap="spacing-4x" flexAlignItemsCenter>
        {__('Essential')}
        <Badge>{__('Yearly billing')}</Badge>
      </Base>
    ) : (
      capitalize(value)
    );

  const durationWording =
    duration === 12
      ? __('year')
      : __('<for-translators-use>Periodicity (month)</for-translators-use>mo');
  return (
    <label tabIndex={0} htmlFor={`plan-${value}-${id}`} className={styles.root}>
      <SrOnly>
        <input
          type="radio"
          id={`plan-${value}-${id}`}
          name={`plan-size-${id}`}
          value={value}
          checked={isSelected}
          onChange={handleClick}
          disabled={disabled}
          tabIndex={-1}
        />
      </SrOnly>

      <PlanContent
        sizeLabel={sizeLabel}
        price={price}
        detail={detail}
        options={options}
        durationWording={durationWording}
      />
    </label>
  );
}
